/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed Deposit`)
};

const es_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depósito Fijo`)
};

const de_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festgeldanlage`)
};

const nl_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaste storting`)
};

const fr_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dépôt Fixe`)
};

const it_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposito Fisso`)
};

const pt_br2_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depósito Fixo`)
};

const pt_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depósito Fixo`)
};

const ja_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期預金`)
};

const zh_sip_fd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期存款`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_fd_nav = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_fd_nav(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_fd_nav", locale)
	if (locale === "en") return en_sip_fd_nav(inputs)
	if (locale === "es") return es_sip_fd_nav(inputs)
	if (locale === "de") return de_sip_fd_nav(inputs)
	if (locale === "nl") return nl_sip_fd_nav(inputs)
	if (locale === "fr") return fr_sip_fd_nav(inputs)
	if (locale === "it") return it_sip_fd_nav(inputs)
	if (locale === "pt-BR") return pt_br2_sip_fd_nav(inputs)
	if (locale === "pt") return pt_sip_fd_nav(inputs)
	if (locale === "ja") return ja_sip_fd_nav(inputs)
	return zh_sip_fd_nav(inputs)
};